import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
  Modal, Form, Button, Col, Spinner,
} from 'react-bootstrap';
import PropTypes from 'prop-types';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import config from '../../../../config';
import { Loader } from '../../../Superadmin/TambahAdmin/styles';

const ModalSetuju = ({
  id, show, onHide, history,
}) => {
  const [statusKonfirm, setStatusKonfirm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [nilaiKUM, setNilaiKUM] = useState();

  useEffect(() => () => {
    setNilaiKUM();
    setLoading(false);
    setStatusKonfirm(false);
  }, [show]);

  const handleSubmit2 = () => {
    setLoading(true);
    const formData = { nilai_kum: nilaiKUM, status: 'disetujui' };
    axios.put(`${config.API_BASE_URL}api/partisipasi_kuliah_umum/detail/${id}/`, formData, {
      headers: {
        accept: 'application/json',
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    }).then(
      () => {
        setLoading(false);
        history.push('/Admin/DaftarPengajuanPartisipasi/DaftarApprovalPartisipasi');
      },
    );
  };

  const handleNilaiKUM = (e) => {
    setNilaiKUM(e.target.value);
  };

  const formik = useFormik({
    initialValues: {
      nilaiKUM,
    },
    validationSchema: Yup.object({
      nilaiKUM: Yup.number().required('Nilai KUM harus diisi!').min(0, 'Nilai KUM tidak boleh negatif!'),
    }),
    onSubmit: () => {
      setLoading(true);
      setStatusKonfirm(!statusKonfirm);
      setLoading(false);
    },
  });

  if (loading) {
    return (
      <Loader>
        <Spinner animation="border" />
      </Loader>
    );
  }

  return (
    <Modal
      show={show}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      onHide={onHide}
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          {' '}
        </Modal.Title>
      </Modal.Header>
      {
        !statusKonfirm
          ? (
            <>
              <Modal.Body>
                <h4 className="font-20">Tentukan KUM</h4>
                <Form onSubmit={formik.handleSubmit} className="form-feedback">
                  <Form.Group controlId="formPlaintextZeroFeedback">
                    <Form.Label column sm="4" className="font-24">Jumlah KUM</Form.Label>
                    <Col sm="8">
                      <Form.Control
                        required
                        type="number"
                        className="font-24"
                        value={nilaiKUM}
                        onChange={(e) => { formik.handleChange(e); handleNilaiKUM(e); }}
                        data-testid="nilaiKUM"
                        name="nilaiKUM"
                      />
                      {formik.errors.nilaiKUM && formik.touched.nilaiKUM && (
                        <div data-testid="nama_kegiatan_error" className="text-danger">{formik.errors.nilaiKUM}</div>
                      )}
                    </Col>
                  </Form.Group>
                  <Button
                    className="btnCancel font-20"
                    variant="danger"
                    onClick={onHide}
                    data-testid="close"
                  >
                    Kembali
                  </Button>
                  <Button
                    type="submit"
                    className="font-20"
                    data-testid="selanjutnya"
                  >
                    Selanjutnya
                  </Button>
                </Form>
              </Modal.Body>
            </>
          )
          : (
            <>
              <Modal.Body>
                <h4>Form Konfirmasi</h4>
                <p>
                  Apakah Anda Ingin mengirim form ini sekarang?
                </p>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  className="btnCancel"
                  variant="danger"
                  onClick={() => setStatusKonfirm(!statusKonfirm)}
                  data-testid="kembali"
                >
                  Kembali
                </Button>
                <Button
                  variant="success"
                  onClick={handleSubmit2}
                  data-testid="konfirmasi"
                >
                  Konfirmasi
                </Button>
              </Modal.Footer>
            </>
          )
        }
    </Modal>
  );
};

ModalSetuju.defaultProps = {
  show: false,
  onHide: () => 'Do Nothing',
  id: '0',
};

ModalSetuju.propTypes = {
  show: PropTypes.bool,
  onHide: PropTypes.func,
  id: PropTypes.string,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

export default ModalSetuju;
